import React, { useMemo, useState } from "react";
import { Typography, Steps } from "antd";
import {
    PlayCircleOutlined,
    AppstoreAddOutlined,
    CrownOutlined,
    ForwardOutlined,
} from "@ant-design/icons";
import CustomCard from "../extraShit/CustomCard";
import { useTranslation } from "react-i18next";
import GamePage from "./GamePage";
import "./busfahren.css";

const { Title, Paragraph, Text } = Typography;

const stepConfigs = [
    {
        key: "setup",
        icon: <AppstoreAddOutlined />,
    },
    {
        key: "roundOne",
        icon: <PlayCircleOutlined />,
    },
    {
        key: "roundTwo",
        icon: <CrownOutlined />,
    },
    {
        key: "finale",
        icon: <ForwardOutlined />,
    },
];

const Busfahren: React.FC = () => {
    const [current, setCurrent] = useState(0);
    const { t } = useTranslation();

    const stepsData = useMemo(
        () =>
            stepConfigs.map((config) => {
                const detailParagraphs = t(
                    `games.details.busfahren.steps.${config.key}.detail`,
                    { returnObjects: true }
                ) as string[];
                const detailList = t(
                    `games.details.busfahren.steps.${config.key}.list`,
                    { returnObjects: true, defaultValue: [] }
                ) as string[];
                const tipKey = `games.details.busfahren.steps.${config.key}.tip`;
                const tipText = t(tipKey, { defaultValue: "" });
                // An empty string in the locale makes i18next return the key itself.
                const tip = tipText === tipKey ? "" : tipText;
                return {
                    ...config,
                    title: t(`games.details.busfahren.steps.${config.key}.title`),
                    summary: t(`games.details.busfahren.steps.${config.key}.summary`),
                    detail: (
                        <div>
                            {detailParagraphs.map((paragraph, index) => (
                                <p key={`${config.key}-p-${index}`}>{paragraph}</p>
                            ))}
                            {detailList.length > 0 && (
                                <ul>
                                    {detailList.map((item, index) => (
                                        <li key={`${config.key}-l-${index}`}>{item}</li>
                                    ))}
                                </ul>
                            )}
                            {tip && (
                                <Text type="secondary">
                                    {tip}
                                </Text>
                            )}
                        </div>
                    ),
                };
            }),
        [t]
    );

    return (
        <GamePage game="busfahren" tagColor="cyan" instructionIcons={stepConfigs.map((step) => step.icon)}>
                <Steps
                    current={current}
                    direction="vertical"
                    items={stepsData.map((step, idx) => ({
                        title: (
                            <span className="busfahren-step-title">
                                {step.title}
                            </span>
                        ),
                        icon: step.icon,
                        description: (
                            <Text type={current === idx ? undefined : "secondary"}>
                                {step.summary}
                            </Text>
                        ),
                        status: current === idx ? "process" : "wait",
                    }))}
                    className="busfahren-steps"
                    onChange={setCurrent}
                />

                <div className="busfahren-detail">
                    <CustomCard
                        title={
                            <Title level={2} className="busfahren-detail__title">
                                {stepsData[current].title}
                            </Title>
                        }
                    >
                        <div className="busfahren-detail__body">{stepsData[current].detail}</div>
                    </CustomCard>
                </div>
                <Paragraph type="secondary" className="busfahren-variant">
                    {t("games.details.busfahren.variant")}
                </Paragraph>
        </GamePage>
    );
};

export default Busfahren;
